/**
 * Show Card / Notice - English
 */
export default {
  close: 'Close',
  contactIfObjection: 'Contact us if you have any objection',
  objectionSubmit: 'Submit Objection',
  objectionContent: 'Objection:',
  placeholderObjectionContent: 'Please describe your objection to this notice',
  objectionContentLength: 'Please enter 10-100 characters',
  submitSuccess: 'Submitted successfully',
  submitFailed: 'Submit failed',
  // commodityRatioMsg
  autoOrderRatioTitle: 'Auto-order Product Ratio',
  agentIdLabel: 'Agent ID:',
  ratioTip: '*Please maintain model ratios accurately. Auto-order will allocate amounts based on these ratios. Total ratio must equal 100%.',
  productModel: 'Product Model',
  ratioCol: 'Ratio',
  ratioTotal: 'Total',
  ratioTotalWithNum: '(Total {num}%)',
  placeholderRatio: 'Enter ratio',
  updateLog: 'Update log:',
  ratioRuleError: 'Please enter valid ratios (1-100 integers) with total equal to 100%',
  saveSuccess: 'Saved successfully',
  saveFailed: 'Save failed',
  // cardShow account upgrade
  accountUpgrade: 'Account Upgrade',
  upgradeIntro: 'Upgrade your agent account to',
  squirrelAiAccount: 'Squirrel AI account',
  upgradeBenefits: 'in one minute. Benefits:',
  unifiedAccount: 'Unified Account',
  unifiedAccountDesc: 'Manage all agent and analyst accounts with one phone number',
  securityPrivacy: 'Security',
  securityDesc: 'Bind phone and DingTalk for account security',
  joinTraining: 'Training',
  trainingDesc: 'Join Squirrel DingTalk for training materials and latest features',
  upgradeNow: 'Upgrade Now',
  giveUpRights: 'Decline',
  bindPhone: 'Bind Phone',
  bindPhoneDesc: 'We will create or bind a Squirrel AI account with your phone number',
  phoneLabel: 'Phone:',
  placeholderPhoneForRecovery: 'Enter phone for password recovery',
  verifyCodeLabel: 'Verify Code:',
  placeholderVerifyCode: 'Enter verify code',
  getVerifyCode: 'Get Code',
  resendAfter: 's to resend',
  resendVerifyCode: 'Resend Code',
  continue: 'Continue',
  scanToActivate: 'Scan to Activate',
  goToDingTalk: 'Complete Upgrade in DingTalk',
  dingTalkStep1: 'Open DingTalk with the phone number you submitted',
  dingTalkStep2: 'You have received a team invitation',
  dingTalkStep3: 'Accept the invitation to complete upgrade',
  refreshHint: 'Accepted? Try',
  refresh: 'Refresh',
  contactSupport: 'Contact Squirrel AI support for help',
  accountUpgraded: 'Account Upgraded',
  mergeAccount: 'Merge Accounts',
  mergeAccountDesc: 'If you have other agent accounts to merge, add them below',
  accountList: 'Account List',
  addAccount: '+ Add Account',
  complete: 'Complete',
  addAgentAccount: 'Add your agent account',
  accountLabel: 'Account:',
  placeholderAccount: 'Enter account',
  passwordLabel: 'Password:',
  placeholderPassword: 'Enter password',
  addAccountBtn: 'Add Account',
  back: 'Back',
  upgradeSuccess: 'Upgrade Success',
  loginWithNewAccount: 'You can log in at',
  loginToExperience: 'to experience upgraded features.',
  useNewAccountLogin: 'Login with new account',
  skip: 'Skip >',
  rulePhoneRequired: 'Please enter phone for password recovery',
  rulePhoneFormat: 'Please enter valid phone number',
  ruleVerifyCodeRequired: 'Please enter verify code',
  ruleVerifyCodeFormat: 'Invalid verify code format',
  pleaseEnterPhone: 'Please enter phone number',
  sendSuccess: 'Sent successfully',
  requestFailed: 'Request failed',
  addSuccess: 'Added successfully',
  addFailed: 'Add failed',
  refreshed: 'Refreshed',
  newNoticeTitle: 'You have a new notice',
  viewNoticeDetail: 'View notice detail',
};
